<template>
  <form @submit="createInclusion($event)">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="inclusion">
            Inclusion Name
            <span
              class="invalid"
              v-if="veeErrors.first('inclusion') && !inclusionForm.name.value"
            >
              - Field is required
            </span>
          </label>
          <input
            name="inclusion"
            type="text"
            v-model.trim="inclusionForm.name.value"
            placeholder="Enter inclusion name"
            class="form-control"
            v-validate="'required|max:100'"
            data-vv-as="inclusion name"
          />
          <div
            v-if="veeErrors.first('inclusion') && inclusionForm.name.value"
            class="invalid-feedback"
          >
            {{ veeErrors.first("inclusion") }}
          </div>
        </div>
        <div class="form-group">
          <label for="description">
            Description
            <span class="invalid" v-if="veeErrors.first('description')">
              - Field is required
            </span>
          </label>
          <textarea
            name="description"
            type="text"
            v-model.trim="inclusionForm.description.value"
            placeholder="Enter description"
            class="form-control"
            v-validate="'required'"
          >
          </textarea>
        </div>
      </div>
    </div>
    <div class="row submit-row ">
      <div class="col d-flex">
        <div
          class="switch"
          @click="handleSwitchClick"
          :class="{ active: isActive === true }"
        >
          <div class="indicator"></div>
        </div>
        <span @click="handleSwitchClick">{{
          isActive ? "Active" : "Inactive"
        }}</span>
      </div>
      <div class="col">
        <ActionButton
          type="submit"
          label="Save"
          :theme="{ primary, secondary, event, danger }"
          style="width: auto; margin-left: auto; margin-top: 0;"
          :disabled="loader"
        />
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/axios";
import { socketSender } from "@/helpers/socket";

export default {
  name: "AddInclusion",
  components: {
    ActionButton
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    },
    link: {
      type: String,
      default: null
    }
  },
  data: () => ({
    editInclusionId: null,
    inclusionForm: {
      name: {
        value: null,
        attributes: [{ required: true }]
      },
      description: {
        value: null,
        attributes: [{ required: true }]
      },
      status: {
        value: null,
        attributes: [{ required: false }]
      }
    },
    inclusionName: null,
    description: null,
    isActive: false,
    apiOptions: {
      mode: "pagination",
      link: null
    },
    loader: false
  }),
  created() {
    this.editSelectedInclusion();
  },
  methods: {
    editSelectedInclusion() {
      if (this.singleRecord) {
        let singleRecord = this.singleRecord;
        let form = this.inclusionForm;

        this.editInclusionId = singleRecord.id;
        this.isActive = singleRecord.status == 2 ? true : false;

        Object.keys(form).map(el => {
          form[el].value = singleRecord[el];
        });
      }
    },
    handleSwitchClick() {
      this.isActive = !this.isActive;
    },
    async createInclusion(event) {
      event.preventDefault();
      let form = this.inclusionForm;
      this.loader = true;

      try {
        let isFormValid = await this.$validator.validateAll();

        if (!isFormValid) {
          let formErrors = await this.$validator.errors;
          if (formErrors.items) {
            formErrors.items.map(error => {
              if (error.rule == "required" || formErrors.items.length > 1) {
                throw {
                  type: "warning",
                  title: "Warning",
                  error: new Error("Please fill the required fields")
                };
              } else {
                throw {
                  type: "error",
                  title: "Warning",
                  error: new Error(
                    "You have reached the maximum limit of characters allowed"
                  )
                };
              }
            });
          }
          throw {
            type: "warning",
            title: "Warning",
            error: new Error("Unable to submit form. Try again.")
          };
        }

        // Arrange Form data for saving
        let formSave = {};
        Object.keys(form).map(el => {
          formSave[el] =
            form[el].value && form[el].value.label
              ? form[el].value.value
              : form[el].value;
          //  For active and inactive
          if (el == "status") {
            formSave[el] = this.isActive == false ? 0 : 2;
          }
        });

        if (this.editInclusionId) {
          // Update category
          await axios.patch("/inclusions/" + this.editInclusionId, formSave);
          this.$emit("close");
        } else {
          /**
           * SOCKET: Add Inclusion
           */
          await socketSender(
            "updateLog",
            `${this.$store.getters.getFullUser} added a new Amenity named ${formSave.name}`
          );
          // Insert new category
          await axios.post("/inclusions", formSave);
          this.$emit("close");
        }

        this.$store.dispatch("FETCH_COLLECTION_PER_PAGE", this.link);

        await this.$toastr.success("Your changes are saved", "Success");
        this.$emit("close");
        this.loader = false;
      } catch (error) {
        const errType = error.type || "error";
        const errTitle = error.title || "Error";
        const errMsg = error.error.message || error.message;

        this.$toastr[errType](errMsg, errTitle);
      } finally {
        this.loader = false;
      }
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss" scoped></style>
